import { NavLink } from 'react-router-dom';

const HomeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 11.5 12 4l9 7.5" />
    <path d="M5 10v10h14V10" />
  </svg>
);

const ExploreIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="9" />
    <path d="M15.5 8.5 13 13l-4.5 2.5L11 11z" />
  </svg>
);

const SocialIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="8.5" cy="9" r="3.5" />
    <circle cx="16.5" cy="10" r="2.5" />
    <path d="M2.5 20c.5-3 3-5 6-5s5.5 2 6 5" />
    <path d="M14 20c.4-2 2-3.5 4-3.5s3.6 1.5 4 3.5" />
  </svg>
);

const ProfileIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="8.5" r="4" />
    <path d="M4 20c1-4 4.5-6 8-6s7 2 8 6" />
  </svg>
);

const tabs = [
  { to: '/', label: 'Home', icon: HomeIcon, end: true },
  { to: '/community', label: 'Explore', icon: ExploreIcon },
  { to: '/friends', label: 'Social', icon: SocialIcon },
  { to: '/profile', label: 'Profile', icon: ProfileIcon },
];

export default function TabBar() {
  return (
    <nav className="tab-bar">
      {tabs.map(({ to, label, icon: Icon, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          className={({ isActive }) => 'tab-bar-item' + (isActive ? ' active' : '')}
        >
          <span className="tab-icon">
            <Icon />
          </span>
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
